import React from "react";
import { Carousel } from "react-responsive-carousel";
import Slide1 from "../assets/images/Entertainment/Entertainment-1.png";
import Slide2 from "../assets/images/Entertainment/Entertainment-2.png";
import Slide3 from "../assets/images/Entertainment/Entertainment-3.png";
import Slide4 from "../assets/images/Entertainment/Entertainment-4.png";
import { trackBannerClicked } from "../utils/mixpanel";
function EntertainmentCarosle({ arr }) {
  return (
    <div className="dot-bar">
      <Carousel
        className="mb-5 noSelect "
        swipeable={true}
        autoPlay={true}
        infiniteLoop={true}
        showIndicators={true}
        showArrows={false}
        showThumbs={false}
        emulateTouch={true}
        showStatus={false}
      >
        {arr
          ? arr.map((slide) => {
              return (
                <div
                  className="carousel-item-custom noSelect"
                  onClick={() => trackBannerClicked({ banner_image: slide, banner_url: "" })}
                >
                  <img src={slide} alt="Slide" />
                </div>
              );
            })
          : null}
      </Carousel>
    </div>
  );
}
export default EntertainmentCarosle;
